



















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItem, SelectItemString } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
@Component({
  components: { EditDayChangePicker }
})
export default class BasicInfo3 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() sex_items!: SelectItem[]; //性別選択アイテムリスト
  @Prop() receipt_special_codes!: SelectItemString[]; //レセプト特記コード
  @Prop() readmission_category_codes!: SelectItemString[]; //再入院等区分コード
  @Prop() partial_payment_category_codes!: SelectItemString[]; //一部負担金区分コード
  @Prop() occupational_reason_codes!: SelectItemString[]; //職務上の事由コード
}
